import { useT } from "../i18n/useT";

export function SocialsCard() {
  const t = useT();

  return (
    <div className="settings-card">
      <h3>{t("settings.socials")}</h3>
      <div className="muted small">{t("settings.socials.hint")}</div>

      <div className="block socials-track">
        <a className="social-card" href="https://github.com/Rumm1" target="_blank" rel="noreferrer" aria-label={t("settings.socials.githubLabel")}>
          <span className="social-photo" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M12 2a10 10 0 0 0-3.16 19.5c.5.1.68-.22.68-.48v-1.7c-2.78.6-3.37-1.2-3.37-1.2-.46-1.18-1.1-1.5-1.1-1.5-.9-.62.07-.6.07-.6 1 .07 1.54 1.06 1.54 1.06.9 1.52 2.35 1.08 2.92.82.1-.65.35-1.08.64-1.32-2.22-.25-4.56-1.1-4.56-4.9 0-1.1.4-2 1.03-2.7-.1-.25-.45-1.28.1-2.66 0 0 .84-.27 2.75 1.02a9.5 9.5 0 0 1 5 0c1.9-1.29 2.74-1.02 2.74-1.02.56 1.38.22 2.4.1 2.66.64.7 1.03 1.6 1.03 2.7 0 3.82-2.35 4.64-4.6 4.88.36.32.7.92.7 1.86v2.75c0 .26.18.58.7.48A10 10 0 0 0 12 2z"
              />
            </svg>
          </span>
          <span className="social-handle">@Rumm1</span>
        </a>

        <a className="social-card" href="https://t.me/liyarum1rei" target="_blank" rel="noreferrer" aria-label={t("settings.socials.telegramLabel")}>
          <span className="social-photo" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M20.5 3.5 2.2 10.4c-.9.35-.88 1.64.04 1.95l4.7 1.6 1.8 5.6c.25.8 1.23 1.06 1.82.47l2.7-2.6 5.1 3.8c.7.5 1.7.1 1.9-.8l3-14.2c.2-1-.7-1.8-1.6-1.5zM9.7 14.7l-.4 3.1-1.2-3.8 9.6-7-8 7.7z"
              />
            </svg>
          </span>
          <span className="social-handle">@liyarum1rei</span>
        </a>

        <a className="social-card" href="https://instagram.com/axeelias" target="_blank" rel="noreferrer" aria-label={t("settings.socials.instagramLabel")}>
          <span className="social-photo" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm10 2H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zm-5 3.5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm0 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm5.2-.9a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
              />
            </svg>
          </span>
          <span className="social-handle">axeelias</span>
        </a>
      </div>
    </div>
  );
}

